import { useFeatureFlagEnabled, usePostHog } from 'posthog-js/react';

import { EFeatureFlag } from '@/shared/types/featureFlag';

type THookRes = {
	isEnabled: boolean;
	variant: string | undefined;
};

export const useFeatureFlag = (flag: EFeatureFlag): THookRes => {
	const posthog = usePostHog();
	const isEnabled = useFeatureFlagEnabled(flag) ?? false;

	const rawValue = posthog?.getFeatureFlag(flag);
	const variant = typeof rawValue === 'string' ? rawValue : undefined;

	return { isEnabled, variant };
};
